import React from "react";
import { PageContent, CustomBreadcrumb } from "components/Common";
import SAHistory from "./SAHistory";
import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const RESOURCE = ModuleIds.SAHistory;

const SAHistoryContainer = ({ t }) => {
  const titleTag = t("Quản lý lịch sử truy cập");
  return (
    <PageContent title={t(titleTag)}>
      {/* Page Title */}
      <CustomBreadcrumb
        breadcrumbItem={titleTag}
        resource={RESOURCE}
        icon={<i className="bx bx-file" />}
      />
      {/* Page Body */}
      <SAHistory />
    </PageContent>
  );
};

SAHistoryContainer.propTypes = {
  t: PropTypes.any,
};

export default withTranslation(["sitePage"])(SAHistoryContainer);
